import { GoogleOneTap } from '@vp/google-one-tap'
import useClient from '../../hooks/useClient'

/**
 * Wrapper component that only renders on the client side.
 * This is necessary because GoogleOneTap requires client-side APIs
 * that are not available during SSR.
 */
export const GoogleOneTapWrapper = () => {
  const isClient = useClient()

  if (!isClient) return null

  return <GoogleOneTap />
}
